<!-- Load main layout here -->
<template src="../templates/MainLayout.html"></template>

<script setup>
    import { computed, ref, onMounted, onUnmounted } from 'vue'
    import { useRoute, useRouter } from 'vue-router'

    import SessionLoginModal from '../apps/SessionLoginModal.vue' 

    // Load and Convert into menu item here
    import MenuItem from '../apps/MenuItem.vue'

    // Load all module item here 
    import { registerMenuRoutes } from '../router/autoRoutes'
    import formConfigJson         from '../apps/jsonForm/demo03.json'
    import dataMenu               from '@/apps/jsonForm/menu.json'
   
    const route      = useRoute()
    const router     = useRouter()
    
    const userName   = ref('User')
    const userAvatar = ref('https://i.pravatar.cc/150')
    const appName    = ref(import.meta.env.VITE_APP_BAR || 'bArBaR Academy')

    // Prepaare for menu items ________________________________________________________________________________
    const menuList      = ref([])
    const isLoadingMenu = ref(false)
    
    const currentRouteName = computed(() => route.name || 'Overview')

    // Mobile Open
    const isMobileOpen = ref(false)

    // Collapse sideMenu
    const isCollapsed = ref(false)

    // Session Timer
    const showSessionModal = ref(false)
    const userEmail        = ref('')
    const timeLeft         = ref('')
    let   timerInterval    = null

    function updateCountdown() {
        const expiresAt = localStorage.getItem('session_expires_at')
        if (!expiresAt) return

        const now = Date.now()
        const diff = parseInt(expiresAt, 10) - now

        if (diff <= 0) {
            clearInterval(timerInterval)
            timeLeft.value = 'Expired'
            // handleLogout('Session expired. Please log in again.')
            showSessionModal.value = true
            return
        }

        const minutes = Math.floor(diff / 60000)
        const seconds = Math.floor((diff % 60000) / 1000)
        timeLeft.value = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
    }

    function handleSessionRenewed() {
        showSessionModal.value = false

        // clean up old interval
        if (timerInterval) clearInterval(timerInterval)
        
        updateCountdown() // Resume countdown tracking
        timerInterval = setInterval(updateCountdown, 1000)
    }

    function toggleSidebar() {
        isCollapsed.value = !isCollapsed.value
    }

    // LIGHT DARK MODE 
    const isDark = ref(true)
    function applyTheme(dark) {
        isDark.value = dark
        if (dark) {
            document.documentElement.classList.add('dark')
            localStorage.setItem('theme', 'dark')
        } else {
            document.documentElement.classList.remove('dark')
            localStorage.setItem('theme', 'light')
        }
    }

    function toggleTheme() {
        applyTheme(!isDark.value)
    }
    // LIGHT DARK MODE 


    // Get Menu from api
    async function fetchUserMenu() {
        const token       = localStorage.getItem('auth_token')
        const userProfile = JSON.parse(localStorage.getItem('user_profile'))
        // console.log("🚀 ~ file: MainLayout.vue:55 ~ userProfile:", userProfile)

        isLoadingMenu.value = true

        try {
            // Disable for temporary !! 
            /*
            const formData = new URLSearchParams()
            formData.append('user_id', '10029')

            const response = await fetch('/api/generate-menu', {
 ±                                           method: 'POST',
                                            headers: {
                                                'Authorization': `Bearer ${token}`,
±                                                'Content-Type': 'application/x-www-form-urlencoded'
                                            },
                                            body: formData
                                    })

            if (response.ok) {
                const data = await response.json()
                menuList.value = data
            } else {
                console.error('Failed to load menu list:', response.statusText)
            }
            */
            
            menuList.value = dataMenu
            registerMenuRoutes(router, menuList.value)

            // Force router to resolve the current path against the newly added routes
            const currentPath = router.currentRoute.value.fullPath
            if (currentPath !== '/') {
                router.replace(currentPath)
            }
        } catch (error) {
            console.error('Error fetching menu:', error)
        } finally {
            isLoadingMenu.value = false            
        }
    }    

    onMounted(() => {
        // LIGHT DARK MODE 
        const savedTheme = localStorage.getItem('theme')

        if (savedTheme) {
            applyTheme(savedTheme === 'dark')
        } else {
            const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
            applyTheme(prefersDark)
        }
        // LIGHT DARK MODE 

        const profileRaw = localStorage.getItem('user_profile')
            if (profileRaw) {
                try {
                    const profile = JSON.parse(profileRaw)
                    userName.value = profile.username || 'User'
                    userEmail.value = profile.member?.email || profile.email || ''
                } catch (e) {
                    console.error('Failed to parse user profile', e)
                }
            }
        // Hit API to grab all menu 
        fetchUserMenu();

        // Timer Here
        updateCountdown()
        timerInterval = setInterval(updateCountdown, 1000)        
    })
  
    // Timer Here
    onUnmounted(() => {
        if (timerInterval) clearInterval(timerInterval)
    })

    function handleLogout() {
        localStorage.removeItem('auth_token')
        localStorage.removeItem('user_profile')
        localStorage.removeItem('session_expires_at')
        router.push('/login')
    }
</script>

<!-- <style src="../../css/main.css"></style> -->
<style>
  @import "tailwindcss";
  @variant dark (&:where(.dark, .dark *));
</style>